import './Login.css'
import { useState, useEffect, ReactNode, FormEvent } from 'react'
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { UserForgotPasswordConfirmationRequestData } from '../api/User';
import { APIRequestPost } from '../utils/APIRequests';

function ForgotPasswordConfirmation(): ReactNode {
    const { t } = useTranslation(['forgot_pass_confirm', 'base']);

    const [errorInfo, setErrorInfo] = useState<ReactNode>(<div></div>);
    const [email, setEmail] = useState<string>("");
    const [token, setToken] = useState<string>("");
    const [passwordValue, setPasswordValue] = useState<string>("");
    const [confirmPasswordValue, setConfirmPasswordValue] = useState<string>("");

    const isAstra = process.env.REACT_APP_SERVICE === 'astra';

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        if (!queryParams.get('email')) {
            console.warn("query missing email");
        }
        if (!queryParams.get('token')) {
            console.log("query mission token");
        }
        setEmail(queryParams.get('email') ?? "");
        setToken(queryParams.get('token') ?? "");
    }, []);

    function submitForm(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();

        if (passwordValue !== confirmPasswordValue) {
            setErrorInfo(<div style={{ paddingTop: "10px" }}>{t('error_pass')}</div>);
            return;
        }

        const data: UserForgotPasswordConfirmationRequestData = {
            password1: passwordValue,
            password2: confirmPasswordValue,
            email: email,
            token: token
        };

        APIRequestPost(`/user/forgotPasswordConfirmation`, {
            data: data
        }).then(() => {
            setErrorInfo(<div style={{ paddingTop: "10px" }}>{t('success')}</div>);
            window.location.href = "/";
        }).catch(() => {
            setErrorInfo(<div style={{ color: "red", paddingTop: "10px" }}>{t('error')}!</div>)
        });
    }

    return (
        <div className='form-page'>
            <div className='form-page-container'>
                {isAstra ? (
                    <div className='console-logo'>
                        <img className='astra-icon' src="/image/astra/astra_logo.svg" alt="" />
                    </div>
                ) : (
                    <div className='console-logo'>Air-link Console</div>
                )}
                <div className='console-logo'>{t('forgot_pass')}</div>
                <Form onSubmit={submitForm}>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>{t('password')}</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder={t('password')}
                            value={passwordValue}
                            onChange={e => setPasswordValue(e.currentTarget.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>{t('password_confirm')}</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder={t('password_placeholder')}
                            value={confirmPasswordValue}
                            onChange={e => setConfirmPasswordValue(e.currentTarget.value)}
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit">
                        {t('submit_button_text')}
                    </Button>
                </Form>
                {errorInfo}
            </div>
        </div>
    )
}

export default ForgotPasswordConfirmation;